import React, { useRef } from 'react';
var VeltNotificationsPanelViewAllButton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-view-all-button", { ref: ref }, children));
};
export default VeltNotificationsPanelViewAllButton;
